export default {
  de: {
    'Hello': 'Hallo'
  },
  en: {
    'will be used automatically since keys are in plain english': ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/LanguageSet.js